import MessageList from './message-list';
import PatternLibraryTopics from "@bonprix/pattern-library/components/topics";
import MessageBrokerUtils from '@bonprix/pattern-library/components/message-broker-utils';

const Topics = MessageBrokerUtils.extractTopics(MessageList);
const EnhancedTopics = Object.assign({}, Topics, PatternLibraryTopics);

Object.freeze(EnhancedTopics);

export default EnhancedTopics;
